import * as React from 'react';
import { set } from 'lodash-es';
import { Component, RuntimeScene, VirtualChildComponent } from '@easytwin/runtime';
import { observer } from 'mobx-react-lite';
import { UISchema } from '@/type';
import { deepClone } from '@/utils';
import { Primitive } from './uicomponents';

export * from './uicomponents';

export interface UIGeneratorProps<T = any> {
  schema: UISchema;
  comp: Component | VirtualChildComponent | RuntimeScene;
  json: T;
  onUpdate: (value: T, changes: { path: string; value: unknown }) => void;
  onConfirm: (value: T, changes: { path: string; value: unknown }) => void;
}

export const UIGenerator: React.FC<UIGeneratorProps> = observer((props) => {
  const { schema, comp, json, onUpdate, onConfirm } = props;

  const onFieldUpdate = (name: string, value: unknown) => {
    if (!json) return;

    const newData = deepClone(json);
    set(newData, name, value);

    onUpdate(newData, { path: name, value });
  };

  const onFieldConfirm = (name: string, value: unknown) => {
    if (!json) return;

    const newData = deepClone(json);
    set(newData, name, value);

    onConfirm(newData, { path: name, value });
  };

  return (
    <>
      {schema.map((a, index) => (
        <Primitive
          key={index}
          schema={a}
          target={json}
          comp={comp}
          onChange={onFieldUpdate}
          onConfirm={onFieldConfirm}
        />
      ))}
    </>
  );
});
